export const Z_INDEX = {
  TILE_HIGHLIGHT: 5,
  PLAYER: 5,
  TILE: 4,
};
